import React, { useState, useEffect } from "react";
import img from '../../assets/success-check.png'
import "./RentalModal.css";
import { useLanguage } from "../../LanguageProvider";
import Services from "../../services/Services";

// Not: MUI kaldırıldı, sade HTML ve mevcut modal CSS kullanılacak

const initialFormData = {
  gondericiAd: "",
  gondericiSoyad: "",
  telefon: "",
  email: "",
  tckn: "",
  bireyselKurumsal: "Bireysel",
  icerikKategori: "",
  paketAdedi: "",
  agirlik: "",
  en: "",
  boy: "",
  yukseklik: "",
  city: "",
  district: "",
  town: "",
  aliciAdSoyad: "",
  aliciTelefon: "",
  acikAdres: "",
  kuryeModel: "",
};

const companies = {
  kurye: ["Vigo"],
  kargo: ["Kargoist"],
};

function CourierCargoForm({ selectedService, setIsOpen, onRequestCreated }) {
  const [formData, setFormData] = useState(initialFormData);
  const [selectedCompany, setSelectedCompany] = useState("");
  const [formErrors, setFormErrors] = useState({});
  const [step, setStep] = useState(1); // 1: form, 2: onay
  const [createdRequest, setCreatedRequest] = useState(null);
  
  // New state variables for location data
  const [token, setToken] = useState(null);
  const [cities, setCities] = useState([]);
  const [towns, setTowns] = useState([]);
  const [districts, setDistricts] = useState([]);

  const { getTranslation } = useLanguage();

  // Fetch token and cities on component mount
  useEffect(() => {
    const fetchTokenAndCities = async () => {
      try {
        const storedToken = localStorage.getItem('token') || "";
        if (!storedToken) {
          console.warn("Token bulunamadı, şehir listesi alınamadı.");
          setCities([]);
          return;
        }
        setToken(storedToken);

        const citiesRes = await Services.GetCities(storedToken);
        setCities(citiesRes.data.result || []);
      } catch (error) {
        console.error('Error fetching token or cities:', error);
        setCities([]);
      }
    };

    fetchTokenAndCities();
  }, []);

  // Fetch towns when city changes
  useEffect(() => {
    if (!token || !formData.city) return;

    const selectedCity = cities.find(c => c.name === formData.city);
    if (!selectedCity) return;

    const fetchTowns = async () => {
      try {
        const res = await Services.GetTowns(token, selectedCity.code);
        setTowns(res.data.result || []);
      } catch (error) {
        console.error('Error fetching towns:', error);
        setTowns([]);
      }
    };

    fetchTowns();
  }, [token, formData.city, cities]);

  // Fetch districts when town changes
  useEffect(() => {
    if (!token || !formData.district) return;

    const selectedTown = towns.find(t => t.name === formData.district);
    if (!selectedTown) return;

    const fetchDistricts = async () => {
      try {
        const res = await Services.GetRegions(token, selectedTown.code);
        setDistricts(res.data.result || []);
      } catch (error) {
        console.error('Error fetching districts:', error);
        setDistricts([]);
      }
    };

    fetchDistricts();
  }, [token, formData.district, towns]);

  // Sadece örnek ücretler
  const summaryPrice = selectedService === "kargo" ? 124 : 84;

  // Form değişikliği
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setFormErrors((prev) => ({ ...prev, [name]: "" }));
  };

  // Basit validasyon
  const validateForm = () => {
    const errors = {};
    if (!selectedCompany) errors.selectedCompany = "Zorunlu alan";
    if (!formData.gondericiAd) errors.gondericiAd = "Zorunlu alan";
    if (!formData.gondericiSoyad) errors.gondericiSoyad = "Zorunlu alan";
    if (!formData.telefon) errors.telefon = "Zorunlu alan";
    if (!formData.email) errors.email = "Zorunlu alan";
    if (selectedService === "kargo") {
      if (!formData.tckn) errors.tckn = "Zorunlu alan";
      if (!formData.icerikKategori) errors.icerikKategori = "Zorunlu alan";
      if (!formData.paketAdedi) errors.paketAdedi = "Zorunlu alan";
      if (!formData.agirlik) errors.agirlik = "Zorunlu alan";
    }
    if (!formData.city) errors.city = "Zorunlu alan";
    if (!formData.district) errors.district = "Zorunlu alan";
    if (!formData.aliciAdSoyad) errors.aliciAdSoyad = "Zorunlu alan";
    if (!formData.aliciTelefon) errors.aliciTelefon = "Zorunlu alan";
    if (!formData.acikAdres) errors.acikAdres = "Zorunlu alan";
    if (selectedService === "kurye" && !formData.kuryeModel) errors.kuryeModel = "Zorunlu alan";
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const generateRandomCode = () => {
    return (
      "EASY" +
      Math.floor(10000000 + Math.random() * 90000000).toString()
    );
  };

  const getNowDateString = () => {
    const now = new Date();
    return now.toLocaleString("tr-TR", { hour12: false });
  };

  // Form submit
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    const newRequest = {
      id: generateRandomCode(),
      date: getNowDateString(),
      ...formData,
      selectedCompany,
      requestType: selectedService,
      price: summaryPrice,
    };
    setCreatedRequest(newRequest);
    setStep(2);
    if (onRequestCreated) onRequestCreated(newRequest);
  };

  // Geri butonu
  const handleBack = () => {
    if (step === 2) setStep(1);
    else setIsOpen(false);
  };

  // Kargo ve Kurye için ücret kutusu verileri
  const renderFeeBox = () => (
    <div className="fee-box">
      <div className="fee-title">{getTranslation('feeInformation')}</div>
      <div className="fee-amount">{summaryPrice.toFixed(2)} TL</div>
      {selectedService === "kargo" && (
        <>
          <div style={{ fontSize: 15, color: '#23272E', marginBottom: 2 }}>
            {getTranslation('estimatedDeliveryDate')}<br />
            <span style={{ color: '#DA3831' }}>{getTranslation('beforeEndOfDay')}</span>
          </div>
          <div className="fee-row"><span>{formData.paketAdedi || getTranslation('onePiece')}</span><span>{formData.icerikKategori || getTranslation('productName')}</span></div>
          <div className="fee-row"><span>{formData.agirlik ? formData.agirlik + getTranslation('kg') : getTranslation('defaultWeight')}</span><span>{formData.desi || getTranslation('defaultDesi')} {getTranslation('desi')}</span></div>
          <div className="fee-row"><span>{formData.en && formData.boy && formData.yukseklik ? `${formData.en}×${formData.boy}×${formData.yukseklik}${getTranslation('cm')}` : getTranslation('defaultDimensions')}</span><span>{formData.desi || getTranslation('defaultDesi')} {getTranslation('desi')}</span></div>
          <input className="modal-input" placeholder={getTranslation('promoCode')} style={{ marginTop: 10, marginBottom: 10 }} />
          <button type="button" className="modal-button" style={{ color: '#DA3831', border: '1px solid #DA3831', marginBottom: 10 }}>{getTranslation('apply')}</button>
        </>
      )}
      {selectedService === "kurye" && (
        <>
          <div className="fee-row"><span>{formData.paketAdedi || getTranslation('onePiece')}</span><span>{formData.icerikKategori || getTranslation('productName')}</span></div>
        </>
      )}
      <div className="fee-row"><span>{getTranslation('kdv')}</span><span>0.00 TL</span></div>
      <div className="fee-row total"><span>{getTranslation('total')}</span><span className="fee-total">{summaryPrice.toFixed(2)} TL</span></div>
    </div>
  );

  // Onay ekranı (Talep Özeti)
  const renderConfirmation = () => (
    <div className="confirmation-box" style={{ width: '100%' }}>
      <div className="modal-title" style={{ marginBottom: 18 }}>{selectedService === 'kargo' ? getTranslation('cargoRequestSummary') : getTranslation('courierRequestSummary')}</div>
      <div style={{width: '100%', background: '#fff', border: '1px solid #D0D5DD', borderRadius: 8, padding: 16, marginBottom: 18, display: 'flex', alignItems: 'center', gap: 10, boxSizing: 'border-box' }}>
        <img width={28} height={28} src={img} alt="" />
        <span style={{ fontWeight: 600, color: '#23272E' }}>{getTranslation('requestSuccessfullyCreated')}</span>
      </div>
      <div style={{ width: '100%', textAlign: 'left', color: '#23272E', fontSize: 17, marginBottom: 8, display : 'flex', flexDirection: 'column', gap: "20px" }}>
        <div style={{ marginBottom: 8 }}>{getTranslation('shipmentCode')}<br /><span style={{ fontWeight: 700 }}>{createdRequest?.id}</span></div>
        <div style={{ marginBottom: 8 }}>{getTranslation('packageCount')}<br /><span style={{ fontWeight: 700 }}>{createdRequest?.paketAdedi || getTranslation('onePiece')}</span></div>
        <div style={{ marginBottom: 8 }}>{getTranslation('creationDate')}<br /><span style={{ fontWeight: 700 }}>{createdRequest?.date}</span></div>
        <div style={{ marginBottom: 8 }}>{getTranslation('shippingCompany')}<br /><span style={{ fontWeight: 700 }}>{createdRequest?.selectedCompany}</span></div>
        <div style={{ marginBottom: 8 }}>{getTranslation('product')}<br /><span style={{ fontWeight: 700 }}>{createdRequest?.icerikKategori || getTranslation('contentCategory')}</span></div>
        {selectedService === 'kargo' && (
          <>
            <div style={{ marginBottom: 8 }}>{getTranslation('packageWeight')}<br /><span style={{ fontWeight: 700 }}>{createdRequest?.agirlik ? `${createdRequest.agirlik} ${getTranslation('kg')} / ${getTranslation('defaultDesi')} ${getTranslation('desi')}` : `${getTranslation('defaultWeight')} ${getTranslation('kg')} / ${getTranslation('defaultDesi')} ${getTranslation('desi')}`}</span></div>
            <div style={{ marginBottom: 8 }}>{getTranslation('packageDimensions')}<br /><span style={{ fontWeight: 700 }}>{createdRequest?.en && createdRequest?.boy && createdRequest?.yukseklik ? `${createdRequest.en}×${createdRequest.boy}×${createdRequest.yukseklik}${getTranslation('cm')}` : getTranslation('notSpecified')}</span></div>
          </>
        )}
        <div style={{ marginBottom: 8 }}>{getTranslation('deliveryAddress')}<br /><span style={{ fontWeight: 700 }}>{createdRequest?.acikAdres || getTranslation('deliveryAddressDetails')}</span></div>
      </div>
      <button className="pay-button" style={{ marginTop: 24 }} onClick={handleBack}>{getTranslation('createNewShipment')}</button>
    </div>
  );

  // Form alanları
  return (
    <div className="service-detail-container">      
      {step === 1 && (
        <h3 className="modal-title">
            {selectedService === "kargo" ? getTranslation('createCargoRequest') : getTranslation('createCourierRequest')}
        </h3>
      )}
      {step === 1 && (
        <form onSubmit={handleSubmit} className="courier-cargo-form">
          <select
            className="modal-input"
            name="selectedCompany"
            value={selectedCompany}
            onChange={(e) => setSelectedCompany(e.target.value)}
            required
          >
            <option value="">{getTranslation('selectCompany')}</option>
            {companies[selectedService].map((c) => (
              <option key={c} value={c}>{c}</option>
            ))}
          </select>
          <div className="form-section-label">{getTranslation('senderInfo')}</div>
          <input className="modal-input" name="gondericiAd" placeholder={getTranslation('senderName')} value={formData.gondericiAd} onChange={handleChange} />
          <input className="modal-input" name="gondericiSoyad" placeholder={getTranslation('senderSurname')} value={formData.gondericiSoyad} onChange={handleChange} />
          <input className="modal-input" name="telefon" placeholder={getTranslation('phoneNumber')} value={formData.telefon} onChange={handleChange} />
          <input className="modal-input" name="email" placeholder={getTranslation('emailAddressLabel')} value={formData.email} onChange={handleChange} />
          {selectedService === "kargo" && (
            <>
              <input className="modal-input" name="tckn" placeholder={getTranslation('tcknNo')} value={formData.tckn} onChange={handleChange} />
              <select className="modal-input" name="bireyselKurumsal" value={formData.bireyselKurumsal} onChange={handleChange}>
                <option value="Bireysel">{getTranslation('individualShipment')}</option>
                <option value="Kurumsal">{getTranslation('corporateShipment')}</option>
              </select>
            </>
          )}
          <div className="form-section-label">{getTranslation('shipmentInfo')}</div>
          {selectedService === "kargo" && (
            <>
              <select className="modal-input" name="icerikKategori" value={formData.icerikKategori} onChange={handleChange}>
                <option value="">{getTranslation('contentCategory')}</option>
                <option value="Elektronik">{getTranslation('electronic')}</option>
                <option value="Giyim">{getTranslation('clothing')}</option>
                <option value="Kitap">{getTranslation('book')}</option>
                <option value="Diğer">{getTranslation('other')}</option>
              </select>
              <input className="modal-input" name="paketAdedi" placeholder={getTranslation('packageCount')} value={formData.paketAdedi} onChange={handleChange} />
              <div style={{ display: 'flex', gap: 8 }}>
                <input className="modal-input" name="en" placeholder={getTranslation('widthCm')} value={formData.en} onChange={handleChange} />
                <input className="modal-input" name="boy" placeholder={getTranslation('heightCm')} value={formData.boy} onChange={handleChange} />
                <input className="modal-input" name="yukseklik" placeholder={getTranslation('depthCm')} value={formData.yukseklik} onChange={handleChange} />
              </div>
              <input className="modal-input" name="agirlik" placeholder={getTranslation('weightDesi')} value={formData.agirlik} onChange={handleChange} />
            </>
          )}
          {selectedService === "kurye" && (
            <>
              <input className="modal-input" name="icerikKategori" placeholder={getTranslation('contentCategory')} value={formData.icerikKategori} onChange={handleChange} />
            </>
          )}
          <select 
            className="modal-input" 
            name="city" 
            value={formData.city} 
            onChange={handleChange}
            required
          >
            <option value="">{getTranslation('selectCity')}</option>
            {cities.map((city) => (
              <option key={city.code} value={city.name}>
                {city.name}
              </option>
            ))}
          </select>

          <select 
            className="modal-input" 
            name="district" 
            value={formData.district} 
            onChange={handleChange}
            required
            disabled={!formData.city}
          >
            <option value="">{getTranslation('selectDistrict')}</option>
            {towns.map((town) => (
              <option key={town.code} value={town.name}>
                {town.name}
              </option>
            ))}
          </select>

          {selectedService === "kurye" && (
            <select 
              className="modal-input" 
              name="town" 
              value={formData.town} 
              onChange={handleChange}
              required
              disabled={!formData.district}
            >
              <option value="">{getTranslation('selectTown')}</option>
              {districts.map((district) => (
                <option key={district.code} value={district.name}>
                  {district.name}
                </option>
              ))}
            </select>
          )}

          {selectedService === "kurye" && (
            <input className="modal-input" name="kuryeModel" placeholder={getTranslation('courierModel')} value={formData.kuryeModel} onChange={handleChange} />
          )}
          <input className="modal-input" name="aliciAdSoyad" placeholder={getTranslation('recipientNameSurname')} value={formData.aliciAdSoyad} onChange={handleChange} />
          <input className="modal-input" name="aliciTelefon" placeholder={getTranslation('recipientPhoneNumber')} value={formData.aliciTelefon} onChange={handleChange} />
          <textarea className="modal-input" name="acikAdres" placeholder={getTranslation('openAddressPlaceholder')} value={formData.acikAdres} onChange={handleChange} style={{ minHeight: 60 }} />

          {renderFeeBox()}
          <button type="submit" className="pay-button">{getTranslation('completePayment')}</button>
        </form>
      )}
      {step === 2 && renderConfirmation()}
    </div>
  );
}

export default CourierCargoForm;
